// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"889":"856920ca","4360":"120bbfef","9500":"856920ca"}[chunkId] + ".chunk.css";
};